import React, { useState } from 'react';
import { AlertTriangle, Flag, X } from 'lucide-react';
import './ReportModal.css';

const ReportModal = ({ isOpen, onClose, onSubmit, entityName }) => {
    const [selectedReason, setSelectedReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const reasons = [
        'محتوى غير لائق / إباحي',
        'تحرش أو تنمر',
        'سب وشتم / إهانة',
        'سبام / إعلانات مزعجة',
        'احتيال أو نصب',
        'سبب آخر'
    ];

    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (!selectedReason) return;
        setIsSubmitting(true);
        await onSubmit(selectedReason);
        setIsSubmitting(false);
        setSelectedReason('');
        onClose();
    };

    return (
        <div className="report-modal-overlay" onClick={onClose}>
            <div className="report-modal-modern" onClick={e => e.stopPropagation()}>
                
                {/* زر الإغلاق العلوي */}
                <button className="btn-close-modal" onClick={onClose} aria-label="إغلاق">
                    <X size={20} />
                </button>

                {/* أيقونة التنبيه */}
                <div className="modal-header-icon">
                    <div className="danger-icon-ring">
                        <AlertTriangle size={32} />
                    </div>
                </div>

                <h3 className="modal-title">إبلاغ عن إساءة</h3>
                <p className="modal-subtitle">
                    أنت تقوم بالإبلاغ عن <span className="highlight-entity">{entityName}</span>. الرجاء تحديد السبب بدقة:
                </p>

                {/* قائمة الأسباب (Custom Radio Buttons) */}
                <div className="report-reasons-list">
                    {reasons.map((reason, idx) => (
                        <div 
                            key={idx} 
                            className={`reason-card ${selectedReason === reason ? 'selected' : ''}`}
                            onClick={() => setSelectedReason(reason)}
                        >
                            <div className="custom-radio">
                                {selectedReason === reason && <div className="radio-dot"></div>}
                            </div>
                            <span className="reason-text">{reason}</span>
                        </div>
                    ))}
                </div>

                {/* أزرار الإجراءات */}
                <div className="report-actions-modern">
                    <button className="btn-cancel-modern" onClick={onClose} disabled={isSubmitting}>
                        إلغاء
                    </button>
                    <button
                        className="btn-submit-danger"
                        onClick={handleSubmit}
                        disabled={!selectedReason || isSubmitting}
                    >
                        {isSubmitting ? (
                            <span className="loader-text">جاري الإرسال...</span>
                        ) : (
                            <>
                                <Flag size={18} /> إرسال البلاغ
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReportModal;

